import React, { useState, useEffect } from 'react';
import { cloneDeep, filter } from 'lodash';
import { toast, ToastContainer } from 'react-toastify';
import { Card, CardBody, Container } from 'reactstrap';
import useAxios from 'hooks/useAxios';
import ErrorBoundary from 'components/ErrorBoundary';
import useContextService from 'hooks/useContextService';
import SearchContainer from './SearchContainer';
import { faAngleUp } from "@fortawesome/free-solid-svg-icons";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { onExport, getUpdatedFilterLatest } from 'utils/helper';
import PharmacySummaryTable from './PharmacyReportsTables/PharmacySummaryTable';
import PharmacyDetailsTable from './PharmacyReportsTables/PharmacyDetailsTable';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';

let filters = [];
let detailFilter = [];

const PharmacyReports = (props) => {
    const { module, orgId } = props;
    const API = useAxios();
    const [data, setData] = useState([]);
    const [totalItem, setTotalItem] = useState(0);
    const [phdetailsData, setDetailData] = useState([]);
    const [detailsTotalItem, setDetailTotalItem] = useState(0);
    const [collapseSider, setcollapseSider] = useState(false);
    const [npiId, setNPIId] = useState([]);
    const [key, setKey] = useState('PharmacySummary');
    const [loading, setLoading] = useState(false);
    const [dateid, setDateId] = useState(0);
    const [columnFilters, setColumnFilters] = useState([]);
    const [lastDataRow, setLastRow] = useState([]);
    const tenantID = npiId;
    const {
        states: { pharmacyreports },
        setStates,
        resetStates,
    } = useContextService();
    const { search, pharmacy, searchTerms, } = pharmacyreports;
    const [collIcon, setCollIcon] = useState(faAngleUp);
    const [dateRange, setDateRange] = useState([]);

    const defaultPharmacyFilter = {
        currentPage: 1,
        pageSize: 100,
        order: 'desc',
        orderBy: 'pharmacyNPI',
        filters: [],
    };

    useEffect(() => {
        if (searchTerms.pharmacyIDs) handleSearch(searchTerms);

    }, []);

    useEffect(() => {
        handleReset();

    }, [orgId]);

    const updateStates = (pharmacyreports) => {
        setStates('pharmacyreports', pharmacyreports);
    };



    //     const updateStates = (tenantID) => {
    // setStates('tenantID', tenantID)
    //     }

    const toggleSider = () => {
        setcollapseSider(!collapseSider);
        if (!collapseSider) {
            setCollIcon(faAngleDown);
        }
        else {
            setCollIcon(faAngleUp);
        }
    }

    const fetchPharmacyDetails = async (filters, row) => {

        detailFilter = {};
        if (!tenantID) return null;
        detailFilter = { ...filters };
        if (row) {
            detailFilter.DetailRow = {};
            detailFilter.DetailRow.pharmacyId = row.pharmacyNPI;
            detailFilter.DetailRow.claimTypeId = row.claimStatusID;
        }
        if (filters.pharmacyId != null) {
            setLoading(true);
            try {
                const { data } = await API.post(`CP2PharmacyReport/${npiId}/PharmacyReports/All`, detailFilter);
                if (data) {
                    // setcollapseSider(true);
                    setCollIcon(faAngleDown);
                    setDetailData(data.items);
                    setDetailTotalItem(data.totalRecords);
                    setLoading(false);

                } else {

                    setDetailData([]);
                    setDetailTotalItem(0);
                    setLoading(false);
                }

            } catch (error) { setLoading(false) }
        }
    };

    const fetchPharmacyReportsList = async (filters) => {
        if (!tenantID) return null;
        if (filters.pharmacyId != null) {
            setLoading(true);
            try {
                const result = await API.post(`CP2PharmacyReport/${npiId}/PharmacyReports/PHSummaryReports`, filters);
                if (result) {
                    // setcollapseSider(true);
                    let rowItems = result.data.items;
                    let lastIndex = rowItems.length - 1;
                    let lastRow = rowItems.splice(lastIndex, 1);
                    if (lastRow.length > 0) {
                        lastRow[0].claimType = "";
                    }
                    //  rowItems = data.items;
                    setCollIcon(faAngleDown);
                    setData(result.data.items);
                    setLastRow(lastRow);
                    setTotalItem(result.data.totalRecords);
                    setLoading(false);
                }
                else {
                    setData([]);
                    setLastRow([]);
                    setTotalItem(0);
                    setLoading(false)
                }
            } catch (error) { setLoading(false); }
        }
    };

    const handleExport = async () => {

        var pageFilters = {};

        const filterObj = cloneDeep(detailFilter);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
        if (detailFilter.DetailRow) {
            var DetailRow1 = {};
            DetailRow1.pharmacyId = detailFilter.DetailRow.pharmacyId;
            DetailRow1.claimTypeId = detailFilter.DetailRow.claimTypeId;
            pageFilters.DetailRow = DetailRow1;
            pageFilters = { ...pageFilters, ...filters }
            filterObj.DetailRow = DetailRow1;
        }
        else {
            pageFilters = { ...detailFilter };
        }

        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = false;
        additionalCriteria.OrgId = 0;
        // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = ce;
        // additionalCriteria.ManufactureId = 0;

        var payload = {};
        payload.tenantID = tenantID;
        payload.gridCode = "pharmacyreportdetail";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
            hasExport: true,
        });
        // toast.success("Downloading is in progress. We will notify you when it is complete.");

        // const { access_token } =
        //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        // const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/PharmacyReports/ExportAll?access_token=${access_token}`;
        // onExport(action, filterObj);
    };

    const handleSummaryExport = async () => {

        const filterObj = cloneDeep(search);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
        }

        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = false;
        additionalCriteria.OrgId = 0;
        // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = ce;
        // additionalCriteria.ManufactureId = 0;

        var payload = {};
        payload.tenantID = tenantID;
        payload.gridCode = "pharmacyreportsummary";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
            hasExport: true,
        });
        //toast.success("Downloading is in progress. We will notify you when it is complete.");


        // const { access_token } =
        //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        // const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/PharmacyReports/ExportSummary?access_token=${access_token}`;
        // onExport(action, filterObj);
    };

    const handelGetNPICode = (data) => {
        setNPIId(data.encryptedNPI)
    };

    const handleSearch = async (filter) => {
        search.filters = [];
        search.orderBy = 'pharmacyNPI';
        const {
            pharmacyId,
            dateRangeID,
            startDate,
            endDate,
            claimTypeId
        } = filter;
        setDateId(dateRangeID);
        var phId = [];

        if (pharmacyId === undefined && searchTerms.pharmacyId.length !== undefined && searchTerms.pharmacyId.length > 0) {
            phId = filter.pharmacyId.map(item => item["value"]);
        }
        else {
            phId = pharmacyId;
        }

        //search.filters = filters;

        search.pharmacyId = phId;
        search.claimTypeId = claimTypeId;
        search.startDate = startDate;
        search.endDate = endDate;
        search.dateRangeID = dateRangeID;
        filters = { ...search }
        //await fetchPharmacyReportsList(search);
        await handlefetchbasedOnreportType(key, filters);
    };

   
   const handlefetchbasedOnreportType = async (value, filters , pageChangeFlag = false) => {
        
 
 
     if (pageChangeFlag == true){
        setKey('PharmacyDetails');
        setColumnFilters([]);
        search.order = ""
         fetchPharmacyDetails(filters) ;
     }
     else {
        // setKey('PharmacyDetails');
       setKey('PharmacySummary');
        fetchPharmacyReportsList(filters)  
     }
        setData([]);
        setLastRow([]);
        setTotalItem(0);
        // if (value == 'PharmacySummary')
        //     fetchPharmacyReportsList(filters);
        // if (value == 'PharmacyDetails') {
 
        //     fetchPharmacyDetails(filters);
        // }
    }
 

   const refetch = () => {
        setColumnFilters([]);
        if (detailFilter.DetailRow && detailFilter.filters.length > 0) {
            detailFilter.filters = [];
            const filter = cloneDeep(detailFilter)
            fetchPharmacyDetails(filter)
        }
        else if (detailFilter.DetailRow && detailFilter.filters) {
            const filter = cloneDeep(detailFilter)
            fetchPharmacyDetails(filter)
        }
        else {
            // filters = [];

if (key ==  'PharmacyDetails' ) {
      detailFilter.filters = [];
            const filter = cloneDeep(detailFilter)
            fetchPharmacyDetails(filter)

}

else if (key == "PharmacySummary") {
            handleSearch(searchTerms);

}
        }
    };

    const handleTabChange = async (value) => {
        setKey(value);

        var cfil = filters;
        filters.orderBy = 'pharmacyNPI';
        cfil.currentPage = 1;

        pharmacyreports.search.currentPage = 1;
        updateStates(pharmacyreports);
        let row = null;
        if (value == 'PharmacySummary')
            fetchPharmacyReportsList(cfil);
        if (value == 'PharmacyDetails') {
            fetchPharmacyDetails(cfil, row);
        }
    };
    const handlePageChange = (filter, haveColFilter) => {
        if (haveColFilter) {
            const filterObj = cloneDeep(search);
            filterObj.filters = [...filterObj.filters, ...filter.filters];
            filterObj.currentPage = filter.currentPage;
            filterObj.pageSize = filter.pageSize;

            pharmacyreports.search.currentPage = filter.currentPage;
            pharmacyreports.search.pageSize = filter.pageSize;
            pharmacyreports.search = { ...pharmacyreports.search };
            fetchPharmacyReportsList(filterObj);

        } else {
            fetchPharmacyReportsList(filter);
            pharmacyreports.search = { ...pharmacyreports.search, ...filter };
        }
        setStates('pharmacyreports', pharmacyreports);
    };

     const handlePageChange1 = (filter, haveColFilter, value) => {

        filter.DetailRow = null;
        var value = "PharmacyDetails";
        if (haveColFilter) {
            handlefetchbasedOnreportType(value, filter , true)

        } else if (detailFilter.DetailRow && value) {

            filter.DetailRow = detailFilter.DetailRow;
            handlefetchbasedOnreportType(value, filter , true)

        }
        else {
            handlefetchbasedOnreportType(value, filter , true)
        }
        pharmacyreports.search = { ...pharmacyreports.search, ...filter };
        setStates('pharmacyreports', pharmacyreports);
    };

    const handleReset = () => {

        setcollapseSider(false);
        setData([]);
        setTotalItem(0);
        setLastRow([]);
        setDetailData([]);
        filters = [];
        detailFilter = [];
        setKey('PharmacySummary');
        setDetailTotalItem(0);
        resetStates('pharmacyreports');
    };

    const handleRowClick = (rowData) => {

        fetchPharmacyDetails(filters, rowData);
        setKey('PharmacyDetails');
    };

    const handleSearchColumnFilters = async (columnFilters) => {

        const filterObj = cloneDeep(search);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
            setColumnFilters(columnFilters);
        }
        await fetchPharmacyReportsList(filterObj);
    };

    const handlePHReportDetailSearchColumnFilters = async (columnFilters) => {

        detailFilter.filters.pop(c => c.filterName == columnFilters[0].filterName);
        const filterObj = cloneDeep(detailFilter);
        pharmacyreports.search.currentPage = 1;
        filterObj.currentPage =1;
        filterObj.filters = [...filterObj.filters, ...columnFilters];
        setColumnFilters(columnFilters);
        setStates('pharmacyreports', pharmacyreports);
        await fetchPharmacyDetails(filterObj)
    }

    const handleSearchColumnFiltersClear = () => {
        setColumnFilters([]);
    }

    const handlePHDetailsExport = async () => {

        var pageFilters = {};

        const filterObj = cloneDeep(detailFilter);
        if (columnFilters && columnFilters.length > 0) {
            filterObj.filters = [...filterObj.filters, ...columnFilters];
        }
        if (detailFilter.DetailRow) {
            var DetailRow1 = {};
            DetailRow1.pharmacyId = detailFilter.DetailRow.pharmacyId;
            DetailRow1.claimTypeId = detailFilter.DetailRow.claimTypeId;
            pageFilters.DetailRow = DetailRow1;
            pageFilters = { ...pageFilters, ...filters }
            filterObj.DetailRow = DetailRow1;
        }
        else {
            pageFilters = { ...detailFilter };
        }

        var additionalCriteria = {};
        additionalCriteria.IsSelectedColumn = true;
        additionalCriteria.OrgId = 0;
        // additionalCriteria.ContractId = 0;
        // additionalCriteria.POId = 0;
        // additionalCriteria.OpaId = 0;
        // additionalCriteria.CEId = ce;
        // additionalCriteria.ManufactureId = 0;

        var payload = {};
        payload.tenantID = tenantID;
        payload.gridCode = "pharmacyreportdetail";
        payload.fileTypeCode = "csv";
        payload.criteria = JSON.stringify(filterObj);
        payload.additionalCriteria = JSON.stringify(additionalCriteria);
        const { data } = await API.post(`export/queue`, payload, {
            hasExport: true,
        });
        // toast.success("Downloading is in progress. We will notify you when it is complete.");


        // const { access_token } =
        //     JSON.parse(sessionStorage.getItem('pharmaforce')) || {};
        // const action = `${process.env.REACT_APP_ENDPOINT}/${process.env.REACT_APP_ENDPOINT_POSTFIX}/${tenantID}/PharmacyReports/ExprortSelectedPHReports?access_token=${access_token}`;
        // onExport(action, filterObj);
    };

    return (
        <div>
            <Container fluid className='width_info'>
                <div className={collapseSider ? "mb-0" : "mb-3"}>
                    <Card className='border-0 shadow-top'>
                        <CardBody hidden={collapseSider} className=''>
                            <ErrorBoundary >
                                <SearchContainer onReset={handleReset} onSearch={handleSearch} orgId={orgId} GetNPIFunction={handelGetNPICode} tenantID={tenantID} defaultPharmacyFilter={defaultPharmacyFilter} />
                            </ErrorBoundary>
                        </CardBody>
                    </Card>
                </div>
                <Card className='border-0 shadow-top '>
                    <CardBody fluid className='bin_info '>
                        <Tabs
                            id="controlled-tab-example"
                            activeKey={key}
                            onSelect={(k) => handleTabChange(k)}
                            className="mb-3"
                        >
                            <Tab eventKey="PharmacySummary" title="Summary">
                                {/* <div className="py-2 text-center">
                                    <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                        <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                                    </span>
                                </div> */}
                                <ErrorBoundary>
                                    <PharmacySummaryTable
                                        module={module}
                                        loading={loading}
                                        data={data}
                                        filters={search}
                                        searchTerms={searchTerms}
                                        totalSize={totalItem}
                                        onExport={handleSummaryExport}
                                        refetch={refetch}
                                        dateid={dateid}
                                        onPageChange={handlePageChange}
                                        onClaimsRowClick={handleRowClick}
                                        onSearchColumnFilters={handleSearchColumnFilters}
                                        toggleSider={toggleSider}
                                        collapseSider={collapseSider}
                                        lastDataRow={lastDataRow}
                                    />
                                </ErrorBoundary>
                            </Tab>
                            <Tab eventKey="PharmacyDetails" title="Details">
                                {/* <div className="py-2 text-center">
                                    <span style={{ fontSize: "27px", cursor: "pointer", }} onClick={toggleSider}>
                                        <FontAwesomeIcon icon={collIcon} className="fa-fw" />
                                    </span>
                                </div> */}
                                <ErrorBoundary>
                                    <PharmacyDetailsTable
                                        module={module}
                                        loading={loading}
                                        data={phdetailsData}
                                        filters={search}
                                        searchTerms={searchTerms}
                                        totalSize={detailsTotalItem}
                                        AllExport={handleExport}
                                        slelectedExport={handlePHDetailsExport}
                                        refetch={refetch}
                                        dateid={dateid}
                                        onPageChange={handlePageChange1}
                                        onSearchColumnFiltersClear={handleSearchColumnFiltersClear}
                                        onSearchColumnFilters={handlePHReportDetailSearchColumnFilters}
                                        toggleSider={toggleSider}
                                        collapseSider={collapseSider}
                                    />
                                </ErrorBoundary>
                            </Tab>
                        </Tabs>
                    </CardBody>
                </Card>
            </Container>
            <ToastContainer position='top-right' autoClose={3000} />
        </div>
    );
};

export default PharmacyReports;
